// extracted by mini-css-extract-plugin
module.exports = {"viewport":"uLxiIb3j0WxoFCkpcSkVyg=="};